import React from "react";

const InfoIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-inherit" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" className={className} viewBox={viewBox}>
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"></path>
      <path fill="currentColor" d="M10 7a1 1 0 100-2 1 1 0 000 2z"></path>
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10 14.5V9"></path>
    </svg>
  );
};

export default InfoIcon;
